import { createI18n } from 'vue-i18n'
import zhCN from './locales/zh-CN.json'
import zhHK from './locales/zh-HK.json'
import enUS from './locales/en-US.json'
import jaJP from './locales/ja-JP.json'

const i18n = createI18n({
  legacy: false,
  locale: 'zh-CN',
  fallbackLocale: 'en-US',
  messages: {
    'zh-CN': zhCN,
    'zh-HK': zhHK,
    'en-US': enUS,
    'ja-JP': jaJP
  },
  datetimeFormats: {
    'zh-CN': {
      short: {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
      }
    },
    'en-US': {
      short: {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
      }
    },
    'ja-JP': {
      short: {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
      }
    }
  }
})

// 自动检测浏览器语言
const savedLang = localStorage.getItem('userLanguage')
const browserLang = navigator.language
const supportedLangs = ['zh-CN', 'zh-HK', 'en-US', 'ja-JP']
const detectedLang = supportedLangs.find(lang => browserLang.startsWith(lang.split('-')[0])) || 'en-US'

if (!savedLang) {
  i18n.global.locale.value = detectedLang
}

export default i18n 